import {Component, EventEmitter, inject, Input, Output, signal} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpStatusCode} from "@angular/common/http";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {CustomMessageService, ResponseHttpError, ResponseHttpSuccess, UtilService} from "library";
import {environment} from "projects/store/src/environments/environment";

enum steps {
  'createAccount' = 'createAccount',
  'accountCreated' = 'accountCreated',
}

@Component({
  selector: 'app-luki-new-client',
  templateUrl: './luki-new-client.component.html',
 })
export class LukiNewClientComponent {
  isLoading = signal<boolean>(false);
  isAccountCreated = signal<boolean>(false);
  id = signal<string>('');
  step = steps.createAccount;
  route = inject(ActivatedRoute);
  requestService = inject(RequestService);
  customMessageService = inject(CustomMessageService);
  utilService = inject(UtilService);
  country = environment.global.country;

  @Input( {required: true} ) visibleLukiNewClientModal!: boolean
  @Input( {required: true} ) request: any

  @Output() optionEventEmit = new EventEmitter();
  @Output() onClose = new EventEmitter<boolean>();




  constructor() {
    this.id.set(this.route.snapshot.params['request_id']);
  }


  closeModal(){
    this.onClose.emit(false);
  }

  onRegisterNewUser(){
    this.isLoading.set(true);
    this.requestService.registerUserOnLuki(this.id()).subscribe({
      next: (response) => {
        if (response.status === HttpStatusCode.NoContent){
          this.isLoading.set(false);
          this.step = steps.accountCreated;
          this.isAccountCreated.set(true);
        }else {
          this.customMessageService.responseNoticeHandler(response);
          this.isLoading.set(false);
        }
      }
    })

  }

  onLukiPayment() {
    this.isLoading.set(true);
    this.utilService.enablePageLoading();

    const data = {luki_wallet_number: this.request.person.phone};

    this.requestService.doLukiCashIn(this.id(), data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Created) {
          this.optionEventEmit.emit(this.id())

        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.isLoading.set(false);
        this.utilService.disablePageLoading()
      },
      error: (error: ResponseHttpError) => {
        if(error.status === HttpStatusCode.NotAcceptable) {
          // TODO como manejar el error
          this.customMessageService.error(error.error.data.message);
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
        this.isLoading.set(false);
        this.utilService.disablePageLoading()
      }
    });
  }


  protected readonly steps = steps;
}
